import { parseDateLoose } from './businessTime';

export function toYMD(dateInput) {
  if (!dateInput) return '';

  let date;

  // Check if the input is in DD/MM/YYYY format
  const ddmmyyyyPattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const match = String(dateInput).match(ddmmyyyyPattern);

  if (match) {
    // Parse DD/MM/YYYY format manually
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1; // Month is 0-indexed in Date
    const year = parseInt(match[3], 10);
    date = new Date(year, month, day);
  } else {
    // Try to parse as-is (for other formats like YYYY-MM-DD, ISO strings, etc.)
    // A bare YYYY-MM-DD is read as a local date, not UTC midnight.
    date = parseDateLoose(dateInput);
  }

  if (!date || isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
